import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { VIDEO_BATCH_TOOL } from '../../modules/tools/data/videoBatchToolContent.js';
import { HEALTH_HAND_VIDEO_TOOL } from '../../modules/tools/data/healthHandVideoToolContent.js';
import { QA_VIDEO_SKILL_TOOL } from '../../modules/tools/data/qaVideoSkillContent.js';
import { STORY_VIDEO_SKILL_TOOL } from '../../modules/tools/data/storyVideoSkillContent.js';
import { COMPARE_VIDEO_TOOL } from '../../modules/tools/data/compareVideoToolContent.js';
import { EXPERT_VIDEO_SKILL_TOOL } from '../../modules/tools/data/expertVideoSkillContent.js';

// Đuôi tiêu đề mọi trang có cụm "đào tạo nhà thuốc" (từ khóa SEO chính); trang chủ dùng tiêu đề đầy đủ HOME_TITLE
const SITE_NAME = 'Đào tạo nhà thuốc';
const HOME_TITLE = 'Đào Tạo Nhà Thuốc Thực Chiến – Khóa Học & Công Cụ Cho Dược Sĩ';

// Tên trang theo đường dẫn: hiện trên tab trình duyệt và ở báo cáo GA4 "Page title".
// Khớp chính xác trước, sau đó khớp theo tiền tố (trang có tham số như /courses/:slug).
const EXACT_TITLES = {
  '/courses': 'Khóa học đào tạo nhà thuốc',
  '/tools': 'Trung tâm công cụ',
  '/tool': 'Công cụ SOP vận hành',
  '/tools/quan-tri-thuc-chien': 'Công cụ SOP vận hành',
  '/tools/do-luong-suc-khoe': 'Đo lường sức khỏe nhà thuốc',
  '/tools/trac-nghiem-thuc-chien': 'Trắc nghiệm kiến thức, kỹ năng',
  '/tools/co-che-luong-thuong': 'Cơ chế lương thưởng quầy thuốc',
  '/tools/chuong-trinh-ban-hang': 'Cẩm nang chương trình bán hàng x2 doanh số',
  '/tools/gia-nhap-that': 'Giá nhập thật',
  [`/tools/${VIDEO_BATCH_TOOL.slug}`]: VIDEO_BATCH_TOOL.name,
  [`/tools/${HEALTH_HAND_VIDEO_TOOL.slug}`]: HEALTH_HAND_VIDEO_TOOL.name,
  [`/tools/${QA_VIDEO_SKILL_TOOL.slug}`]: QA_VIDEO_SKILL_TOOL.name,
  [`/tools/${STORY_VIDEO_SKILL_TOOL.slug}`]: STORY_VIDEO_SKILL_TOOL.name,
  [`/tools/${COMPARE_VIDEO_TOOL.slug}`]: COMPARE_VIDEO_TOOL.name,
  [`/tools/${EXPERT_VIDEO_SKILL_TOOL.slug}`]: EXPERT_VIDEO_SKILL_TOOL.name,
  [EXPERT_VIDEO_SKILL_TOOL.guidePath]: `Hướng dẫn ${EXPERT_VIDEO_SKILL_TOOL.name}`,
  '/login': 'Đăng nhập',
  '/register': 'Đăng ký',
  '/dashboard': 'Trang học viên',
  '/profile': 'Hồ sơ cá nhân',
  '/checkout/result': 'Kết quả thanh toán',
};
const PREFIX_TITLES = [
  ['/admin', 'Quản trị'],
  ['/courses/', 'Chi tiết khóa học'],
  ['/learn/paths/', 'Học theo lộ trình'],
  ['/learn/', 'Bài học'],
  ['/quiz/', 'Bài kiểm tra'],
  ['/checkout/', 'Thanh toán'],
];

function titleFor(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (EXACT_TITLES[path]) return EXACT_TITLES[path];
  const hit = PREFIX_TITLES.find(([prefix]) => path.startsWith(prefix));
  return hit ? hit[1] : null;
}

/**
 * Mỗi lần đổi trang (React Router): đặt tiêu đề tab theo trang và gửi page_view lên GA4.
 * GA4 gắn ở public/index.html với send_page_view: false, nên page_view chỉ gửi từ đây (kể cả trang đầu tiên).
 * Trên GA4 phải TẮT "Page changes based on browser history events" (Đo lường nâng cao) để không bị đếm đôi.
 */
export function PageViewTracker() {
  const location = useLocation();
  const lastSent = useRef(null);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    const name = titleFor(location.pathname);
    document.title = name ? `${name} | ${SITE_NAME}` : HOME_TITLE;

    // StrictMode ở máy dev chạy effect 2 lần; cùng một trang chỉ gửi 1 lần
    if (lastSent.current === pagePath || typeof window.gtag !== 'function') return;
    lastSent.current = pagePath;
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: pagePath,
    });
  }, [location.pathname, location.search]);

  return null;
}
